module.exports = __webpack_public_path__ + "icon-tibco-ems.2MBWVlZL.svg";